import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioSelectComponent } from './radio-select.component';
import { SelectionModule } from '@library/ui/molecules/selection/selection.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectionModule,
  ],
  exports: [
    RadioSelectComponent,
  ],
  declarations: [RadioSelectComponent]
})
export class RadioSelectModule { }
